import ForgotPasswordForm from "./forgot-password-form.container";
export default ForgotPasswordForm;